export default "__VITE_ASSET__Z44LSHtV__"